(() => {
  document.querySelectorAll('[data-sh-mobile-product]').forEach(section => {
    if (section.dataset.shMobileBound) return;
    section.dataset.shMobileBound = 'true';
    const slot = section.querySelector('[data-sh-mobile-reviews]');
    if (!slot) return;
    const mobile = window.matchMedia('(max-width: 749px)');
    const heading = section.querySelector('.sh-mobile-product-heading');
    const desktopHeader = section.querySelector('.product-single__meta .product-block--header');
    const headingAnchor = document.createComment('');
    if (heading && desktopHeader) heading.before(headingAnchor);
    let badge, block, anchor, scheduled = false;
    const update = () => {
      scheduled = false;
      if (!section.isConnected) return;
      if (heading && desktopHeader) {
        if (mobile.matches) {
          if (heading.previousSibling !== headingAnchor) headingAnchor.after(heading);
          if (section.hasAttribute('data-sh-desktop-heading')) section.removeAttribute('data-sh-desktop-heading');
        } else {
          if (heading.parentNode !== desktopHeader) desktopHeader.append(heading);
          if (!section.hasAttribute('data-sh-desktop-heading')) section.setAttribute('data-sh-desktop-heading', '');
        }
      }
      if (!badge?.isConnected) {
        badge = section.querySelector('.jdgm-preview-badge');
        block = badge?.closest('.shopify-app-block') || badge;
        if (!block) return;
        anchor = document.createComment('');
        block.before(anchor);
      }
      const data = badge.matches('[data-number-of-reviews]') ? badge : badge.querySelector('[data-number-of-reviews]');
      const count = Number(data?.getAttribute('data-number-of-reviews'));
      const rating = Number(data?.getAttribute('data-average-rating'));
      const hasReviews = Number.isFinite(count) && count > 0 && Number.isFinite(rating) && rating > 0;
      if (mobile.matches) {
        if (block.parentNode !== slot) slot.append(block);
        slot.hidden = !hasReviews;
      } else {
        if (anchor?.parentNode && block.previousSibling !== anchor) anchor.after(block);
        slot.hidden = true;
      }
    };
    const schedule = () => {
      if (scheduled) return;
      scheduled = true;
      requestAnimationFrame(update);
    };
    new MutationObserver(schedule).observe(section, {childList:true,subtree:true,attributes:true,attributeFilter:['data-number-of-reviews','data-average-rating']});
    mobile.addEventListener('change', update);
    update();
  });
})();
